import createReducer from '../utils/createReducer';
import actions from '../actions/discontinuedBrand';

const initialState = {};

const actionHandlers = {
    [actions.DISCONTINUED_BRAND_DISMISS_ALERT_BOX](state, {}) {
        return {
            ...state,
            serviceError: ''
        };
    }
};

export default createReducer(actionHandlers, initialState);
